import { filter } from 'lodash';
import { createSelector } from 'reselect';
import { RootStateType } from '../rootReducer';

export const selectEPG = (state: RootStateType) => state.epg;

export const selectIsVisible = createSelector(selectEPG, (epg) => !!epg.isVisible);

export const selectIsLoading = createSelector(selectEPG, (epg) => !!epg.isLoading);

export const selectData = createSelector(selectEPG, (epg) => epg.data);

export const selectDataById = createSelector(
  selectData,
  (_, props) => props.id,
  (data, id) => data[id],
);

export const selectUpdatedAt = createSelector(selectEPG, (epg) => epg.updatedAt);

export const selectChannelsWithEPG = createSelector(
  selectData,
  (_, props) => props,
  (epg, { channels, onlyFavorites }) => {
    const source = onlyFavorites ? filter(channels, 'favorite') : channels;

    return source.map((channel) => {
      return { ...channel, epg: epg[channel.id] };
    });
  },
);
